// extracted by mini-css-extract-plugin
export default {"container":"AdditionalDetails_container__9QhVg","field":"AdditionalDetails_field__zl16-","crmLink":"AdditionalDetails_crmLink__ptmZS","avatar":"AdditionalDetails_avatar__1DYdD"};